import { render, staticRenderFns } from "./EventCalendarWeek.vue?vue&type=template&id=bbd7c87a&"
import script from "./EventCalendarWeek.vue?vue&type=script&lang=js&"
export * from "./EventCalendarWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports